import dayjs from 'dayjs';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VDatePicker } from '@/package';
import { DATEPICKER_MODE } from '@/package/kiska/src/component/UI/VDatePicker/constant';

import type { TaskCreateFormType } from './type';

export const TaskDueDate = ({ readOnly }: { readOnly: boolean }) => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    setValue,
    getValues,
    formState: { touchedFields },
  } = useFormContext<TaskCreateFormType>();
  const startDate = watch('startDate');
  const dueDate = watch('dueDate');

  const validate = () => {
    const currentStartDate = getValues('startDate');
    const currentDueDate = getValues('dueDate');
    const isStartDateValid = dayjs(
      currentStartDate,
      'YYYY-MM-DD',
      true,
    ).isValid();
    const isDueDateValid = dayjs(currentDueDate, 'YYYY-MM-DD', true).isValid();
    return isStartDateValid && isDueDateValid;
  };

  return (
    <VDatePicker
      fluid
      required
      mode={DATEPICKER_MODE.RANGE}
      label={t('task.createTaskDateLabel.scalage')}
      placeholder="YYYY-MM-DD ~ YYYY-MM-DD"
      {...register('startDate', { validate: () => validate() })}
      value={[startDate ?? new Date(), dueDate ?? new Date()]}
      onChange={([from, to]) => {
        setValue('startDate', dayjs(from).format('YYYY-MM-DD'), {
          shouldValidate: true,
        });
        setValue('dueDate', dayjs(to).format('YYYY-MM-DD'), {
          shouldValidate: true,
        });
      }}
      valid={!touchedFields.startDate || validate()}
      readOnly={readOnly}
    />
  );
};
